<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Nueva condición / Add Conditions</h5>
    <div mat-dialog-content>
      <!--begin::Form-->
      <form class="form" [formGroup]="newConditionForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
          <br-alert *ngIf="showAlert"></br-alert>
          <p><strong>ID: </strong>1</p>
          <p><strong>Fecha de creación / Date: </strong>{{date | date: 'MMMM d, y'}}</p>
          <mat-form-field class="w-100">
            <mat-label>Condición / Conditions</mat-label>
            <input matInput type="text"
              formControlName="condition" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('condition', 'required')">
              <strong>Campo requerido / Field Required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <!--end::Form-->
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
      <button mat-button cdkFocusInitial (click)="submit(newConditionForm)">Guardar / Save</button>
    </div>
  </div>
